<template>
  <div id="inspectionReportList">
    <div id="container-center">
      <div class="labelTitle lable">点検報告書一覧</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>点検実施月</th>
            <td>
              <input type="month" style="width: 200px" :min="startMonth" :max="endMonth" v-model="searchConditions.startMonth"/> ～
              <input type="month" style="width: 200px" :min="startMonth" :max="endMonth" v-model="searchConditions.endMonth"/>
            </td>
          </tr>

          <tr>
            <th>公開月</th>
            <td>
              <input
                type="month"
                style="width: 200px; float:left;"
                :min="startMonth"
                :max="endMonth"
                v-model="searchConditions.publishedMonth"
              />
              <b-checkbox 
                class="columnCheckBox"
                style="padding-left: 20px"
                v-model="searchConditions.isRepublish"
              >
                再公開
              </b-checkbox>
            </td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="data.length > 0">
        <div style="float: left">
          <b-button class="is-primary" :disabled="!checkedRows.length" @click="download"> ダウンロード </b-button>
        </div>

        <div>
          <b-table
            id="inspectionReportListTable"
            :data="data"
            :paginated="isPaginated"
            per-page="100"
            pagination-position="both"
            default-sort="completionDate"
            default-sort-direction="desc"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            checkable
            :checked-rows.sync="checkedRows"
            checkbox-position="left"
          >
            <template slot-scope="props">
              <b-table-column
                field="completionDate"
                label="点検実施日"
                width="100"
                sortable
              >
                {{ props.row.completionDate }}
              </b-table-column>
              <b-table-column
                field="recipientName"
                label="患者名"
                width="130"
                sortable
              >
                {{ props.row.recipientName }}
              </b-table-column>
              <b-table-column
                field="productName"
                label="点検機器"
                width="150"
                sortable
              >
                {{ props.row.productName }}
              </b-table-column>
              <b-table-column
                field="publishedDate"
                label="公開日"
                width="100"
                sortable
              >
                {{ props.row.publishedDate }}
              </b-table-column>
              <b-table-column
                field="isRepublish"
                label="再公開"
                width="80"
                sortable
              >
                <b-icon v-if="props.row.isRepublish" icon="check"></b-icon>
              </b-table-column>
              <b-table-column label="参照" width="80" centered>
                <a @click="goView(props.row)"><b-icon icon="file-outline" /></a>
              </b-table-column>
            </template>
          </b-table>
        </div>

        <div>
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { role } from "@/components/mock/base/const.js";

export default {
  name: "inspectionReportList",
  methods: {
    back: function () {
      this.$router.push({
        name: "guestHome",
      });
    },
    goView: function(row) {
      // 点検報告書参照
      this.$router.push({
        name: "InspectionReportView",
        params: {
          fromPageName: "inspectionReportList",
          preSearchConditions: this.searchConditions,
          inspectionReport: row,
        }
      });
    },
    doSearch: function () {
      const _this = this;
      this.apiCall(
        function (client) {
          const body = {};
          if (_this.searchConditions.startMonth) {
            body.startMonth = _this.searchConditions.startMonth;
          }
          if (_this.searchConditions.endMonth) {
            body.endMonth = _this.searchConditions.endMonth;
          }
          if (_this.searchConditions.publishedMonth) {
            body.publishedMonth = _this.searchConditions.publishedMonth;
          }
          body.isRepublish = _this.searchConditions.isRepublish;
          return client.apis.smsInspectionReport.getSmsInspectionReportsPOST(
            {
              body,
            }
          );
        },
        function (result) {
          const body = result.body;
          _this.data = body;
        },
        function (result) {
          _this.showErrorMessage(result);
        }
      );
    },
    getSmsInspectionReportRange: async function () {
      const _this = this;
      this.apiCall(
        function (client) {
          return client.apis.smsInspectionReport.getSmsInspectionReportRangePOST(
            {
            }
          );
        },
        function (result) {
          const body = result.body;
          _this.startMonth = body.startMonth;
          _this.endMonth = body.endMonth;
        },
        function (result) {
          _this.showErrorMessage(result);
        }
      );
    },
    download: function () {
      const _this = this;
      this.downloadApiCall(
        function (client) {
          const body = [];
          for (const checkedRow of _this.checkedRows) {
            const elem = {
              appointmentCode: checkedRow.appointmentCode,
              inspectionId: checkedRow.inspectionCode,
              printType: checkedRow.kind,
              sendType: checkedRow.sendType,
              destinationId: checkedRow.destinationId,
            };
            body.push(elem)
          }
          return client.apis.smsInspectionReport.downloadSmsInspectionReportsPOST(
            {
              body,
            }
          );
        },
        function (result) {
          _this.showErrorMessage(result);
        }
      );
      return;
    },
  },

  data() {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    const preSearchConditions = this.$route.params["preSearchConditions"];
    const searchConditions = {
      startMonth: null,
      endMonth: null,
      publishedMonth: null,
      isRepublish: false,
    }

    return {
      data: [],
      isPaginated: true,
      userInfo,
      preSearchConditions,
      searchConditions,
      checkedRows: [],
      startMonth: null,
      endMonth: null,
    };
  },

  filters: {},

  components: {},

  mounted: async function () {
    if (this.userInfo.roleId != role.role_hospital) {
      this.back();
    }
    if (!this.userInfo.smsHospitalCode) {
      await this.showErrorMessage(
        "呼吸点検報告書サービスを利用するための設定が完了していません。\nPhilips担当支店へのご連絡をお願い致します。"
      );
      this.back();
    }
    this.getSmsInspectionReportRange();
    if (this.preSearchConditions) {
      this.searchConditions = this.preSearchConditions;
      this.preSearchConditions = {};
      this.doSearch();
    }
  },
};
</script>

<style lang="scss" scoped>
.conditionTable th {
  width: 100px;
}
.conditionTable td {
  width: 400px;
}
a {
  text-decoration: underline;
}
.tag {
  width: 100px;
}

#item-contens table tr th {
  width: 70px;
}

#item-contens table tr td button {
  width: 165px;
  margin-right: 3px;
}
.button-group {
  margin-top: 2px;
}
.file-dialog {
  z-index: 20;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/inspectionReportList.vue